import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export default function UpgradeGate({ requiredTier = "mid", feature = "This feature" }) {
  const label = requiredTier === "premium" ? "Premium" : "Mid";
  return (
    <div className="panel p-10 max-w-lg mx-auto text-center celestial" data-testid="upgrade-gate">
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-primary/10 mb-5">
        <Lock className="text-primary" size={22} />
      </div>
      <h2 className="font-serif text-3xl mb-2">{feature} is a {label} feature</h2>
      <p className="text-muted-foreground mb-6">Upgrade your membership to unlock it and go deeper with your companion.</p>
      <Link to="/pricing" data-testid="gate-upgrade-link"
        className="gold-btn inline-flex items-center gap-2 px-7 py-3 rounded-full font-medium">
        <Sparkles size={16} /> See memberships
      </Link>
    </div>
  );
}
